import React, { memo } from 'react'
import { compose } from 'redux'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import ClearIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close'
import RedirectTo from '../../../Common/RedirectTo'

const styles = theme => ({
  buttonWrapper: {
    padding: 8,
  },
  button: {
    width: '100%',
    color: theme.palette.secondary.light,
    textTransform: 'none',
  },
  iconWrapper: {
    padding: 8,
  },
  clearIcon: {
    color: theme.palette.secondary.light,
  },
})

const SelectedCustomer = ({
  classes,
  disabled,
  customer,
  onCustomerChange,
}) => (
  <Grid container alignItems="center" justify="flex-start" wrap="nowrap">
    <div className={classes.buttonWrapper}>
      <Button
        className={classes.button}
        size="small"
        disabled={disabled}
        onClick={event => {
          RedirectTo.customer(customer.id)
        }}
      >
        <Typography variant="subtitle1" noWrap>
          {customer.name}
        </Typography>
      </Button>
    </div>
    <div className={classes.iconWrapper}>
      <IconButton disabled={disabled} onClick={() => onCustomerChange({})}>
        <ClearIcon classes={{ colorPrimary: classes.clearIcon }} />
      </IconButton>
    </div>
  </Grid>
)

export default compose(withStyles(styles), memo)(SelectedCustomer)
